export const SET_BOOKING_TIME_TOKEN = 'SET_BOOKING_TIME_TOKEN';
export const setbookingTimeToken = (token) => ({type : SET_BOOKING_TIME_TOKEN, token})
